import React from 'react'
import { createPortal } from 'react-dom'

import PageSectionTitle from '../ui/pageSectionTitle'
import './styles.scss'

export type InvoiceOverlayModalProps = {
  open: boolean
  onClose: () => void
  title?: string
  description?: string
  modalClassName?: string
  children: React.ReactNode
}

const InvoiceOverlayModal: React.FC<InvoiceOverlayModalProps> = ({
  open,
  onClose,
  title,
  description,
  modalClassName,
  children,
}) => {
  React.useEffect(() => {
    if (typeof document === 'undefined' || !open) return

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [open])

  const handleBackdropMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  if (!open) return null

  return createPortal(
    <div className='invoice-client-modal-backdrop' onMouseDown={handleBackdropMouseDown}>
      <div className={`invoice-client-modal card border-3 p-5 bg-white${modalClassName ? ` ${modalClassName}` : ''}`}>
        {(title != null) && (
          <div className='mb-4'>
            <PageSectionTitle title={title} description={description} />
          </div>
        )}
        {children}
      </div>
    </div>,
    document.body,
  )
}

export default InvoiceOverlayModal
